import { render, staticRenderFns } from "./CompanyInvoicesCards.vue?vue&type=template&id=bd016824&"
import script from "./CompanyInvoicesCards.vue?vue&type=script&lang=ts&"
export * from "./CompanyInvoicesCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports